import { Location } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { DEEPLINK_STORAGE_KEY, OVERVIEW_ROUTE } from '@rci/self-serve-fido/app.constant';
import { SESSION_STORAGE } from '@rogers/self-serve-utils/storage';

@Injectable({ providedIn: 'root' })
export class DeeplinkService {
  private readonly sessionStorage = inject<Storage>(SESSION_STORAGE);
  private readonly location = inject(Location);
  private readonly router = inject(Router);

  private deepLinkUrl: string;

  processDeeplink() {
    if (!this.deepLinkUrl) {
      this.router.navigate([OVERVIEW_ROUTE]);
    }

    this.router.navigateByUrl(this.deepLinkUrl);
    this.deepLinkUrl = '';
  }

  storeDeeplinkState(state: RouterStateSnapshot) {
    this.deepLinkUrl = state.url;
    this.sessionStorage.setItem(DEEPLINK_STORAGE_KEY, this.location.prepareExternalUrl(state.url));
  }
}
